export const CUSTOMER_SERVICE_OPEN_EVENT = "customer-service:open";
export const CUSTOMER_SERVICE_EXTERNAL_GAME_RETURN_KEY = "customer-service:external-game-return";

export const markCustomerServiceExternalGameReturn = () => {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return;
  }

  try {
    window.sessionStorage.setItem(CUSTOMER_SERVICE_EXTERNAL_GAME_RETURN_KEY, "1");
  } catch (error) {
    console.error("mark customer service external game return failed", error);
  }
};

export const consumeCustomerServiceExternalGameReturn = () => {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return false;
  }

  try {
    const shouldRestore = window.sessionStorage.getItem(CUSTOMER_SERVICE_EXTERNAL_GAME_RETURN_KEY) === "1";
    if (shouldRestore) {
      window.sessionStorage.removeItem(CUSTOMER_SERVICE_EXTERNAL_GAME_RETURN_KEY);
    }
    return shouldRestore;
  } catch (error) {
    console.error("consume customer service external game return failed", error);
    return false;
  }
};

export const openCustomerService = () => {
  if (typeof window === "undefined") {
    return;
  }

  let event;
  if (typeof window.CustomEvent === "function") {
    event = new CustomEvent(CUSTOMER_SERVICE_OPEN_EVENT);
  } else {
    event = document.createEvent("CustomEvent");
    event.initCustomEvent(CUSTOMER_SERVICE_OPEN_EVENT, false, false, null);
  }
  window.dispatchEvent(event);
};
